import React from 'react'
import styled from 'styled-components'
import Swiper from 'react-id-swiper'
import Link from 'gatsby-link'
import media from '../../styles/media'

import '../../../node_modules/react-id-swiper/src/styles/scss/swiper.scss'

import Slider from 'react-slick'
import shortid from 'shortid'

import develop from '../../assets/images/carousel/develop.jpg'
import ecommerce from '../../assets/images/carousel/ecommerce.jpg'
import icare from '../../assets/images/carousel/icare.jpg'
import loyalty from '../../assets/images/carousel/loyalty.jpg'
import smarty from '../../assets/images/carousel/smarty.jpg'

const StyledSwiper = styled.div`
  .swiper-container {
    padding-bottom: 3rem;
    margin: auto;
    @media (max-width: 768px) {
      max-width: 100%;
    }
    .swiper-pagination-bullet-active {
      background: #40b4e4;
    }
  }
`

const ItemWrapper = styled.div`
  &.swiper-slide {
    width: auto;
    .overlay {
      width: 100%;
      max-width: 320px;
      height: 100%;
      background-color: rgba(60, 66, 82, 0.6);
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      margin: auto;
      display: none;
    }
    &.swiper-slide-active {
      &:hover {
        cursor: pointer;
        .overlay {
          display: block;
          z-index: 2;
        }
        .title {
          color: white;
          z-index: 3;
        }
      }
    }
  }
`

const StyledItem = styled.div`
  text-align: center;
  position: relative;
`

const StyledTitle = styled(Link)`
  &.title {
    font-size: 1rem;
    text-decoration: none;
    position: absolute;
    bottom: 10%;
    left: 0;
    right: 0;
    margin: auto;
    text-transform: uppercase;
    font-weight: bold;
    color: #3c4252;
    padding-left: 5rem;
    padding-right: 5rem;
    letter-spacing: 2.8px;
    @media (max-width: 768px) {
      padding: 0 1rem;
      word-wrap: break-word;
      font-size: 0.75rem;
    }
  }
`

const StyledImg = styled.img`
  border-radius: 5px;
`

const Title = styled.h3`
  margin: 0 0 20px;
  font-size: 20px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: center;
  color: #3c4252;
  ${media.md`
    font-size: 25px;
  `};
`

const Intro = styled.p`
  margin: 0 0 30px;
  font-size: 15px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #3c4252;
  ${media.md`
    font-size: 18px;
  `};
`

const Carousel = props => {
  let { className } = props

  const images = [
    { key: shortid.generate(), src: loyalty, title: 'Loyalty', to: '/loyalty' },
    {
      key: shortid.generate(),
      src: icare,
      title: 'AUTOMATIZACIÓN DE MARKETING',
      to: '/icare'
    },
    {
      key: shortid.generate(),
      src: develop,
      title: 'Desarrollo',
      to: '/develop'
    },
    {
      key: shortid.generate(),
      src: smarty,
      title: 'ESTRATEGIA DIGITAL Y ANALÍTICA',
      to: '/smarty'
    },
    {
      key: shortid.generate(),
      src: ecommerce,
      title: 'Ecommerce',
      to: '/ecommerce'
    }
  ]

  const slides = images.map(image => (
    <ItemWrapper key={image.key}>
      <StyledItem>
        <StyledImg className="img-fluid" src={image.src} alt={image.title} />
        <StyledTitle to={image.to} className="title">
          {image.title}
        </StyledTitle>
        <Link to={image.to} className="overlay" />
      </StyledItem>
    </ItemWrapper>
  ))

  const params = {
    effect: 'coverflow',
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: 3,
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 150,
      modifier: 2,
      slideShadows: false
    },
    pagination: {
      el: '.swiper-pagination',
      clickeable: true
    },
    initialSlide: 2,
    rebuildOnUpdate: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
        coverflowEffect: {
          stretch: -30
        }
      }
    },
    loop: true,
    loopedSlides: 10,
    autoplay: {
      delay: 5000,
      disableOnInteraction: true
    },
    preloadImages: true,
    keyboard: true,
    mousewheel: {
      invert: true
    },
    preventInteractionOnTransition: true,
    slideToClickedSlide: true
  }
  return (
    <StyledSwiper className={className}>
      <div className="row">
        <div className="col-md-12">
          <Title>Nuestras líneas de negocio</Title>
          <Intro>
            Te ayudamos en la transformación digital que necesita tu empresa
          </Intro>
          <Swiper {...params}>{slides}</Swiper>
        </div>
      </div>
    </StyledSwiper>
  )
}

export default Carousel



// WEBPACK FOOTER //
// ./src/components/carousel/carousel.js